<template>
<div class="banner-sticky-container">
    <div id="banner-container" class="banner-container">
        <div class="flex">
            <i class="fa-kit fa-jbg-logo seasonal-icon" />
            <p class="sale-text">{{ $t('SALE_BANNER.BANNER_TEXT') }}</p>
            <NuxtLink :to="navigateToCtaRoute" class="homepage-banner cta-btn">
                <div role="button" tab-index="0" class="homepage-banner" target="_blank">
                    {{ $t('SALE_BANNER.BUTTON_TEXT') }}
                </div>
            </NuxtLink>
            <div
                role="button" tabIndex="0" aria-label="close sale banner"
                v-on:click="close"
                v-on:keydown.enter="close"
            >
                <i class="fa-solid fa-xmark close" />
            </div>
        </div>
    </div>
</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import type { RouteLocation } from 'vue-router'

export default defineComponent({
    props: {
        bannerName: {
            type: String,
            required: true
        }
    },

    emits: ['close'],

    computed: {
        navigateToCtaRoute(): RouteLocation {
            return this.localeRoute({
                name: 'sale'
            })
            // return this.localeRoute({
            //     path: '/blog/jackbox-direct-2025'
            // })
        }
    },

    mounted() {},

    beforeUnmount() {},

    methods: {
        close() {
            this.setBannerTimeoutCookie()
            this.$emit('close')
        },

        setBannerTimeoutCookie() {
            // don't show the banner again for a week
            const expDate = new Date()
            expDate.setDate(expDate.getDate() + 7)
            document.cookie = `name=${this.bannerName}_banner_timeout; expires=${expDate.toUTCString()}; Secure`
        }
    }
})
</script>

<style lang="scss" scoped>
@use "$styles/kit.scss" as *;

$gradient-bg: linear-gradient(122deg, rgba(82, 44, 148, 0.32) 0%, rgba(130, 62, 117, 0.32) 50%, rgba(148, 97, 38, 0.32) 100%), #000;
$gradient-border: linear-gradient(90deg, #5A2DE8 10%, #DC983A 50%, #D25BC9 100%);
$border-width: 3px;
$border-radius: 32px;

.banner-sticky-container {
    animation: slide-up 0.7s linear;
    position: sticky;
    width: 100%;
    max-width: 100vw;
    bottom: 0;
    /*ensures this will be on top of the zendesk chat button, which has a z-index of 999999*/
    z-index: 1000000;

    .banner-container {
        max-width: 100vw;
        background: $gradient-bg;
        background-clip: padding-box;
        border-top: $border-width solid transparent;

        position: relative;
        padding: 20px 32px;

        &:before {
            content: '';
            position: absolute;
            top: 0; right: 0; bottom: 0; left: 0;
            z-index: -1;
            margin-top: -$border-width;
            border-radius: inherit;
            background: $gradient-border;
        }

        @keyframes slide-up {
            0% {transform: translateY(500px);}
            100% {transform: translateY(0px);}
        };

        @include mq-xsmall {
            border-top-left-radius: $border-radius;
            border-top-right-radius: $border-radius;
            border-left: $border-width solid transparent;
            border-right: $border-width solid transparent;
            padding: 0 12px 0 12px;
            &:before {
                margin-left: -$border-width;
                margin-right: -$border-width;
            }
        }

        .flex {
            align-items: center;
            display: flex;
            flex-direction: row;

            @include mq-xsmall {
                flex-direction: column;
                gap: 16px;
            }

            .close {
                width: 34px;
                height: 34px;

                :hover {
                    cursor: pointer;
                    color: #F9A629;
                }

                @include mq-xsmall {
                    position: absolute;
                    top: 14px;
                    right: 14px;
                }
            }

            @include mq-xsmall {
                .homepage-banner {
                    width: 100%;
                }
            }

            .cta-btn {
                align-items: center;
                background-color: rgb(255 255 255 / 24%);
                border-radius: 10px;
                color: var(--primary-50);
                display: flex;
                font-weight: 500;
                font-size: 16px;
                height: 40px;
                justify-content: center;
                margin: 0 20px;
                width: 140px;

                @include mq-xsmall {
                    width: 100%;
                    text-align: center;
                    margin: auto;
                }

                &:hover {
                    cursor: pointer;
                    border: 1px solid var(--primary-50);
                    box-sizing: border-box;
                }
            }

            .sale-text {
                font-size: 18px;
                font-weight: 400;
                line-height: 18px;
                margin: auto 0;
                flex: 1;

                display: -webkit-box;
                -webkit-line-clamp: 4; /* number of lines to show */
                line-clamp: 4;
                -webkit-box-orient: vertical;
                overflow: clip;
                overflow-clip-margin: 2px;

                @include mq-xsmall {
                    font-size: 15px;
                    text-align: center;
                    max-width: 380px;
                }
            }

            .seasonal-icon {
                font-size: 40px;
                height: 40px;
                width: 40px;
                margin-right: 16px;

                @include mq-xsmall {
                    margin-top: 12px;
                    margin-right: 0px;
                }
            }
        }
    }
}

</style>
